/**
* Endpoint methods related to the Webshop Payment
*/
import API from "./Api";


export default {
  /**
  * Creates a Webshop Payment
  */
  async create(body) {

    return API.post("/webshoppaymentcharge/create", body, "MOODLE_SESSION_JSON");
  },

};